const translations = {
  fr: {
    // ── Auth ──
    auth_title: "Accéder à mon Coffre",
    auth_register_title: "Créer mon Coffre",
    auth_email: "Adresse email",
    auth_password: "Mot de passe",
    auth_name: "Votre prénom",
    auth_login: "Entrer",
    auth_register: "Créer mon compte",
    auth_forgot: "Mot de passe oublié ?",
    auth_back_login: "Retour à la connexion",
    auth_no_account: "Pas encore de coffre ?",
    auth_has_account: "Déjà un coffre ?",
    auth_create: "En créer un",
    auth_connect: "Se connecter",
    auth_reset_title: "Réinitialiser le mot de passe",
    auth_reset_code: "Code reçu par email",
    auth_new_password: "Nouveau mot de passe",
    auth_reset_submit: "Changer le mot de passe",
    auth_reset_sent: "Un code a été envoyé à votre email",
    auth_send_code: "Envoyer le code",

    // ── Dashboard ──
    dash_my_treasures: "Mes Trésors",
    dash_eclairages: "Éclairages",
    dash_prestige: "Services de Prestige",
    dash_cercle: "Mon Cercle",
    family_title: "Cercle Familial",
    family_desc: "Invitez jusqu'a 5 proches a consulter et alimenter votre Tronc Commun. Vos souvenirs prives restent prives.",
    family_create: "Creer mon Cercle Familial",
    family_heritage_required: "Le Cercle Familial est inclus dans l'offre Heritage.",
    family_see_plans: "Decouvrir L'Heritage",
    family_my_circle: "Mon Cercle Familial",
    family_guardian_label: "Vous etes le Gardien",
    family_members: "membres",
    family_invite_prompt: "Inviter un proche \u00e0 alimenter vos souvenirs par email",
    family_invite_send: "Inviter",
    family_members_title: "Membres du Cercle",
    family_no_members: "Aucun membre pour l'instant. Envoyez votre premiere invitation !",
    family_tronc_commun: "Tronc Commun",
    family_tronc_desc: "Partagez des photos depuis l'onglet \"Mes Tresors\" pour les rendre visibles a votre Cercle.",
    family_refresh: "Actualiser",
    family_circle_of: "Cercle de",
    family_member_label: "Vous etes membre",
    family_leave: "Quitter le Cercle",
    family_load_photos: "Charger les souvenirs",
    family_no_shared: "Le Gardien n'a pas encore partage de souvenirs dans le Tronc Commun.",
    family_gauge_label: "Places dans votre ecrin",
    family_seats_left: "places disponibles",
    family_seat_left: "place disponible",
    family_full: "Votre Cercle est au complet",
    // ── L'Alliance (Parrainage) ──
    alliance_tab: "L'Alliance",
    alliance_title: "L'Alliance",
    alliance_subtitle: "Parrainez un proche et recevez chacun 1 mois offert",
    alliance_your_code: "Votre code de parrainage",
    alliance_share_link: "Lien de parrainage",
    alliance_copy: "Copier",
    alliance_copied: "Copie !",
    alliance_share_whatsapp: "Partager via WhatsApp",
    alliance_share_text: "Rejoins-moi sur Bobine, le coffre-fort de souvenirs ! Utilise mon code pour recevoir 1 mois offert :",
    alliance_how_title: "Comment ca marche ?",
    alliance_step1: "Partagez votre lien avec un proche",
    alliance_step2: "Votre filleul cree son compte avec votre code",
    alliance_step3: "Des qu'il souscrit a un abonnement, vous recevez chacun 1 mois offert",
    alliance_my_referrals: "Mes filleuls",
    alliance_no_referrals: "Aucun filleul pour l'instant. Partagez votre lien !",
    alliance_status_pending: "En attente",
    alliance_status_active: "1 mois offert",
    alliance_bonus_used: "Votre mois offert a ete applique",
    alliance_bonus_available: "Votre bonus sera applique des qu'un filleul souscrit",
    alliance_one_bonus_note: "Un bonus de parrainage par utilisateur",
    dash_add_video: "Ajouter une bobine vive",
    dash_videos_title: "Bobine Vive — souvenirs en mouvement",
    ecl_send_by_email: "Envoyer par email",
    ecl_email_placeholder: "Email de votre proche",
    ecl_email_sent: "Email envoy\u00e9 !",
    ecl_email_sending: "Envoi...",
    album_all: "Tous",
    album_create: "Album",
    album_name_placeholder: "Nom de l'album...",
    album_confirm: "Creer",
    dash_timeline: "Frise",
    dash_vault_title: "Mon Coffre-fort",
    dash_my_account: "Mon Profil",
    dash_sas_full_title: "Le Passage au Tamis",
    dash_upload: "Déposer des Trésors",
    dash_select: "Sélectionner",
    dash_cancel: "Annuler",
    dash_invite_eclaireur: "Inviter un Éclaireur",
    dash_share_silk: "Le Fil de Soie — Partager mes Trésors",
    dash_treasures_sealed: "Trésors scellés",
    video_too_large: "Ce souvenir est un peu trop lourd pour être scellé d'un coup (max 500 Mo).",
    dash_add_treasure: "Ajouter un Trésor",
    dash_share_desc: "Partagez vos Trésors en lecture seule avec vos proches.",
    dash_logout: "Quitter",
    menu_account: "Mon Profil",
    menu_billing: "Facturation",
    menu_plans: "Offres & Tarifs",
    account_title: "Mon Profil",
    account_since: "Membre depuis",
    profile_language: "Langue",
    dash_video_memory: "Souvenir en mouvement",
    download_btn: "T\u00e9l\u00e9charger",
    delete_btn: "Supprimer",
    account_vault: "Mon Coffre-fort en un coup d'oeil",
    account_photos: "Photos en stock",
    account_used: "utilis\u00e9",
    account_sas: "Dans le Sas",
    account_book: "Dans le Livre",
    account_restored: "Restaur\u00e9es",
    account_encrypted: "Chiffr\u00e9es S3",
    account_livres: "Livres command\u00e9s",
    account_num: "Num\u00e9risations",
    account_eclaireurs: "Mes \u00c9claireurs",
    account_no_eclaireurs: "Aucun \u00e9claireur invit\u00e9 pour le moment",
    account_comments: "Commentaires re\u00e7us",
    account_subscription: "Mon Abonnement",
    account_billing: "Facturation",
    account_upgrade: "Changer d'offre",
    account_shares: "Liens de partage",
    dash_no_photos: "Votre coffre est vide",
    dash_no_photos_sub: "Déposez vos premiers trésors pour commencer",
    dash_sas_title: "Passage au Tamis",
    dash_sas_desc: "photos à trier",
    dash_restore: "Restaurer",
    dash_edit_date: "Modifier la date",
    dash_delete: "Supprimer",
    dash_delete_selected: "Supprimer",
    dash_back: "Retour",
    dash_back_vault: "Retour au Coffre-fort",
    dash_remaining: "restant",
    dash_remaining_plural: "restants",
    dash_board: "Tableau de Bord",

    // ── Navigation ──
    nav_home: "Accueil",
    nav_discover: "Découvrir nos formules",
    nav_books: "Nos Livres d'Art",
    nav_crafts: "Artisanat & Mémoire",
    nav_navigation: "Navigation",

    // ── Welcome ──
    dash_welcome: "Bienvenue dans votre sanctuaire,",
    dash_welcome_member: "cher membre",
    dash_welcome_text: "Le fil de votre histoire commence ici. Chaque photo que vous déposez est une empreinte que vous laissez au temps.",
    dash_drag_drop: "ou glissez-déposez vos photos ici",
    dash_drop_here: "Déposez vos souvenirs ici",

    // ── SAS ──
    dash_sas_label: "Sas de Tri",
    dash_sas_waiting: "en attente de tri — 30 jours avant suppression",
    dash_sort: "Trier",

    // ── Batch ──
    dash_batch_modify_date: "Modifier la date",
    dash_batch_same_date_single: "La même date sera appliquée à la photo sélectionnée.",
    dash_batch_same_date_plural: "La même date sera appliquée à toutes les photos sélectionnées.",
    dash_apply: "Appliquer",
    dash_applying: "Application...",
    dash_batch_delete_confirm: "Supprimer",
    dash_batch_deleting: "Suppression...",

    // ── Éclaireur ──
    ecl_title: "L'Éclaireur",
    ecl_invite_title: "Inviter un Éclaireur",
    ecl_subtitle: "vous invite à éclairer ses souvenirs",
    ecl_enter_name: "Votre prénom pour participer",
    ecl_choose_photos: "Choisissez les photos à partager",
    ecl_choose_memories: "Choisissez les souvenirs à partager",
    ecl_select_all: "Tout sélectionner",
    ecl_deselect_all: "Tout désélectionner",
    ecl_selected: "sélectionné",
    ecl_selected_plural: "sélectionnés",
    ecl_message_placeholder: "Un message personnel (optionnel)",
    ecl_send_invitation: "Envoyer l'invitation",
    ecl_link_ready: "Lien Magique prêt !",
    ecl_magic_link: "Votre Lien Magique",
    ecl_copy_link: "Copier le lien",
    ecl_copied: "Copié !",
    ecl_generating: "Génération...",
    ecl_generate_link: "Générer le Lien Magique",
    ecl_link_created: "Lien Magique créé !",
    ecl_link_share_desc: "Partagez ce lien avec vos proches pour qu'ils éclairent vos souvenirs.",
    ecl_share_whatsapp: "Partager sur WhatsApp",
    ecl_whatsapp_share_msg: "Coucou, c'est {name} ! Regarde ce souvenir que j'ai retrouvé sur Bobine. Ca va te plaire !",
    ecl_memories_shared: "souvenir partagé",
    ecl_memories_shared_plural: "souvenirs partagés",
    ecl_comment_placeholder: "Partagez votre souvenir...",
    ecl_send_comment: "Envoyer",
    ecl_record_voice: "Confier un récit vocal",
    ecl_comments_title: "Commentaires",
    ecl_tap_to_comment: "Touchez une photo pour commenter ou confier un recit vocal",
    ecl_whatsapp_btn: "J'ai terminé — Prévenir sur WhatsApp",
    ecl_whatsapp_msg: "Coucou ! Je viens de déposer un petit morceau de notre histoire sur ton Fil de Soie Bobine. 🕊️ Quel plaisir de revoir ces moments... Hâte que tu l'écoutes ! ✨",
    ecl_listen: "Écouter",
    ecl_stop: "Arrêter",
    ecl_transcription: "Transcription",

    // ── Viewer ──
    viewer_sealed_on: "Scellé le",
    viewer_add_caption: "Ajouter une légende...",
    viewer_restore_progress: "Restauration de l'éclat en cours...",
    viewer_restore_title: "Restauration Renaissance",
    viewer_before: "AVANT",
    viewer_after: "APRES",
    viewer_restore_btn: "Restaurer",
    viewer_close: "Fermer",
    viewer_comments: "Commentaires",
    restore_accept: "Je valide cette restauration",
    restore_reject: "Non merci, annuler",

    // ── Modération ──
    mod_pending: "En attente",
    mod_approve: "Approuver",
    mod_reject: "Rejeter",
    mod_approved: "Approuvé",
    mod_no_pending: "Aucun éclairage en attente",
    mod_no_pending_sub: "Les commentaires de vos Éclaireurs apparaîtront ici",
    mod_description: "Approuvez ou rejetez les commentaires laissés par vos Éclaireurs.",
    mod_visible_desc: "Les commentaires approuvés seront visibles sur votre Fil de Soie.",

    // ── Fil de Soie ──
    silk_title: "Le Fil de Soie",
    silk_subtitle: "partage ses souvenirs avec vous",
    silk_close: "Fermer",

    // ── Partage ──
    share_title: "Le Fil de Soie",
    share_subtitle: "Partagez vos trésors avec vos proches",
    share_generate: "Générer un lien de partage",
    share_message_placeholder: "Un message pour accompagner vos photos...",
    share_my_links: "MES LIENS ACTIFS",
    share_copy: "Copier",
    share_revoke: "Révoquer",
    share_no_links: "Aucun lien actif",

    // ── Audio ──
    audio_record: "Confier un récit vocal",
    audio_recording: "Enregistrement...",
    audio_stop: "Arrêter",
    audio_pause: "Pause",
    audio_resume: "Reprendre",
    audio_send: "Envoyer",
    audio_delete: "Supprimer l'audio",
    audio_listen: "Écouter",
    audio_transcription: "Transcription",

    // ── Services ──
    svc_subscription: "Mon Abonnement",
    svc_lignees: "L'Héritage",
    svc_heritage: "L'Héritage",
    svc_eveil: "L'Éveil",
    svc_free: "Gratuit — 50 Trésors",
    svc_heritage_desc: "4,99€/mois — Stockage Illimité",
    svc_lignees_desc: "4,99€/mois — Stockage Illimité",
    svc_upgrade: "Choisir l'Héritage",
    svc_upgrade_lignees: "Choisir l'Héritage",
    svc_manage_subscription: "Gérer mon abonnement",
    svc_books: "Nos Livres d'Art",
    svc_discount: "-20% appliqué automatiquement sur tous les livres",
    svc_order: "Commander",
    svc_redirect: "Redirection...",
    svc_restore_free: "Restaurer maintenant",
    svc_restore_paid: "Restaurer une photo",
    svc_digitize: "Numérisation de vos Trésors",
    svc_digitize_desc: "Confiez vos photos, albums et négatifs à notre conservateur. Numérisation professionnelle haute résolution.",
    svc_discover: "Découvrir",
    svc_digitize_title: "Service de Numérisation Pro",
    svc_order_book: "Commander mon Livre",
    svc_treasures: "Trésors",
    svc_unlimited: "Illimité",
    svc_request_sent: "Demande transmise !",
    svc_request_sent_desc: "Votre demande a été transmise à notre conservateur. Nous vous recontactons sous 24h.",

    // ── Quota ──
    quota_message: "Vous avez scellé vos premiers Trésors avec succès. Pour continuer à protéger l'histoire de votre lignée, passez à l'offre supérieure ou activez votre abonnement.",

    // ── Doublons ──
    dup_title: "Doublons détectés",
    dup_found: "doublon(s) trouvé(s)",
    dup_group: "Groupe de doublons",
    dup_keep: "Garder",
    dup_remove: "Supprimer",
    dup_no_duplicates: "Aucun doublon détecté",
    dup_scanning: "Analyse en cours...",
    dup_banner_desc: "photos identiques trouvées dans votre coffre",
    dup_manage: "Gérer les doublons",
    dup_select_to_delete: "Sélectionnez les photos à supprimer dans chaque groupe",
    dup_delete_selected: "Supprimer les doublons sélectionnés",
    dup_identical: "photos identiques",
    dup_clean_success: "Doublons supprimés avec succès",

    // ── Général ──
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    confirm: "Confirmer",
    cancel: "Annuler",
    close: "Fermer",
    save: "Enregistrer",
    photos: "photos",
    photo: "photo",

    // ── Book / Grid ──
    book_photos_count: "photos dans votre Livre",
    book_preserve_dna: "Préservez l'ADN de vos souvenirs",
    book_in_book: "DANS LE LIVRE",
    book_add: "Ajouter au livre",
    book_remove: "Retirer du livre",
    view_grid: "Grille",
    view_timeline: "Frise",

    // ── Verify Email ──
    verify_title: "Vérification de votre email",
    verify_desc: "Un code à 6 chiffres a été envoyé à",
    verify_enter_code: "Entrez le code reçu",
    verify_confirm: "Confirmer",
    verify_confirming: "Vérification...",
    verify_not_received: "Vous n'avez pas reçu le code ?",
    verify_resend: "Renvoyer le code",
    verify_resending: "Envoi...",
    verify_resent: "Code renvoyé !",
    verify_logout: "Se déconnecter",

    // ── Landing ──
    landing_hero: "Redonnez vie à vos souvenirs oubliés",
    landing_cta: "Commencer",
    landing_skip: "PASSER",
    home_slogan: "Votre coffre-fort de souvenirs",
    home_discover: "Découvrir Bobine",
    home_upload: "Déposer vos souvenirs",
    home_drag_drop: "ou glissez vos photos ici",
    home_save: "Sauvegarder dans mon coffre",
    home_saved: "Sauvegardé dans Mes Trésors !",
    home_replay: "Revoir l'introduction",
    fondatrice_desc: "L'histoire de Bobine, racontée par celle qui l'a imaginée.",
    ob_slide1: "Redonnez vie à vos souvenirs oubliés",
    ob_slide2: "Le patrimoine de votre lignée, scellé pour l'éternité",
    ob_video_text: "Le fil est entre vos mains, scellez votre histoire.",
    ob_cta_text: "Le fil est entre vos mains,",
    ob_cta_text2: "scellez votre histoire.",
    ob_enter: "Entrer dans le Coffre-fort",
    ob_next: "Suivant",
    ob_replay: "Revoir l'introduction",
    ob_skip: "Passer",
    loader_preparing: "Pr\u00e9paration",
    loader_turbo: "Turbo Upload",
    loader_photos_sec: "photos/s",
    loader_finalizing: "Finalisation de votre collection...",
    loader_remaining: "restant(s)",
    badge_sovereignty: "Souverainet\u00e9 Suisse",
    badge_sovereignty_desc: "Vos souvenirs sont chiffr\u00e9s et h\u00e9berg\u00e9s en Suisse",
    murmure_open: "Replonger dans mes souvenirs",
    share_video: "Partager",
    fondatrice_trial_cta: "D\u00e9couvrez l'\u00e9crin Bobine\u00a0: 30 jours de s\u00e9r\u00e9nit\u00e9 offerts",
  },

  en: {
    // ── Auth ──
    auth_title: "Access my Vault",
    auth_register_title: "Create my Vault",
    auth_email: "Email address",
    auth_password: "Password",
    auth_name: "Your first name",
    auth_login: "Enter",
    auth_register: "Create my account",
    auth_forgot: "Forgot password?",
    auth_back_login: "Back to login",
    auth_no_account: "No vault yet?",
    auth_has_account: "Already have a vault?",
    auth_create: "Create one",
    auth_connect: "Log in",
    auth_reset_title: "Reset password",
    auth_reset_code: "Code received by email",
    auth_new_password: "New password",
    auth_reset_submit: "Change password",
    auth_reset_sent: "A code has been sent to your email",
    auth_send_code: "Send code",

    // ── Dashboard ──
    dash_my_treasures: "My Treasures",
    dash_eclairages: "Insights",
    dash_prestige: "Premium Services",
    dash_cercle: "My Circle",
    family_title: "Family Circle",
    family_desc: "Invite up to 5 loved ones to browse and contribute to your Shared Trunk. Your private memories stay private.",
    family_create: "Create my Family Circle",
    family_heritage_required: "Family Circle is included in the Heritage plan.",
    family_see_plans: "Discover Heritage",
    family_my_circle: "My Family Circle",
    family_guardian_label: "You are the Guardian",
    family_members: "members",
    family_invite_prompt: "Invite a loved one by email",
    family_invite_send: "Invite",
    family_members_title: "Circle Members",
    family_no_members: "No members yet. Send your first invitation!",
    family_tronc_commun: "Shared Trunk",
    family_tronc_desc: "Share photos from the \"My Treasures\" tab to make them visible to your Circle.",
    family_refresh: "Refresh",
    family_circle_of: "Circle of",
    family_member_label: "You are a member",
    family_leave: "Leave Circle",
    family_load_photos: "Load shared memories",
    family_no_shared: "The Guardian hasn't shared any memories to the Shared Trunk yet.",
    family_gauge_label: "Seats in your circle",
    family_seats_left: "seats available",
    family_seat_left: "seat available",
    family_full: "Your Circle is complete",
    // ── L'Alliance (Referral) ──
    alliance_tab: "L'Alliance",
    alliance_title: "L'Alliance",
    alliance_subtitle: "Refer a loved one and each get 1 free month",
    alliance_your_code: "Your referral code",
    alliance_share_link: "Referral link",
    alliance_copy: "Copy",
    alliance_copied: "Copied!",
    alliance_share_whatsapp: "Share via WhatsApp",
    alliance_share_text: "Join me on Bobine, the memory vault! Use my code for 1 free month:",
    alliance_how_title: "How does it work?",
    alliance_step1: "Share your link with a loved one",
    alliance_step2: "Your referral creates an account with your code",
    alliance_step3: "Once they subscribe, you both get 1 free month",
    alliance_my_referrals: "My referrals",
    alliance_no_referrals: "No referrals yet. Share your link!",
    alliance_status_pending: "Pending",
    alliance_status_active: "1 free month",
    alliance_bonus_used: "Your free month has been applied",
    alliance_bonus_available: "Your bonus will be applied when a referral subscribes",
    alliance_one_bonus_note: "One referral bonus per user",
    dash_add_video: "Add a live reel",
    dash_videos_title: "Bobine Vive — memories in motion",
    ecl_send_by_email: "Send by email",
    ecl_email_placeholder: "Your loved one's email",
    ecl_email_sent: "Email sent!",
    ecl_email_sending: "Sending...",
    album_all: "All",
    album_create: "Album",
    album_name_placeholder: "Album name...",
    album_confirm: "Create",
    dash_timeline: "Timeline",
    dash_vault_title: "My Vault",
    dash_my_account: "My Account",
    dash_sas_full_title: "The Sieve",
    dash_upload: "Add Treasures",
    dash_select: "Select",
    dash_cancel: "Cancel",
    dash_invite_eclaireur: "Invite a Scout",
    dash_share_silk: "The Silk Thread — Share my Treasures",
    dash_treasures_sealed: "Treasures sealed",
    video_too_large: "This memory is a bit too large to be sealed at once (max 500 MB).",
    dash_add_treasure: "Add a Treasure",
    dash_share_desc: "Share your Treasures read-only with loved ones.",
    dash_delete_selected: "Delete",
    dash_logout: "Log out",
    menu_account: "My Profile",
    menu_billing: "Billing",
    menu_plans: "Plans & Pricing",
    account_title: "My Profile",
    account_since: "Member since",
    profile_language: "Language",
    account_vault: "My Vault at a glance",
    account_photos: "Photos in stock",
    account_used: "used",
    account_sas: "In the Vault",
    account_book: "In the Book",
    account_restored: "Restored",
    account_encrypted: "Encrypted S3",
    account_livres: "Books ordered",
    account_num: "Scans",
    account_eclaireurs: "My Scouts",
    account_no_eclaireurs: "No scouts invited yet",
    account_comments: "Comments received",
    account_subscription: "My Subscription",
    account_billing: "Billing",
    account_upgrade: "Change plan",
    account_shares: "Share links",
    dash_no_photos: "Your vault is empty",
    dash_no_photos_sub: "Upload your first treasures to get started",
    dash_sas_title: "The Sieve",
    dash_sas_desc: "photos to sort",
    dash_restore: "Restore",
    dash_edit_date: "Edit date",
    dash_delete: "Delete",
    dash_back: "Back",
    dash_back_vault: "Back to Vault",
    dash_remaining: "remaining",
    dash_remaining_plural: "remaining",
    dash_board: "Dashboard",

    // ── Navigation ──
    nav_home: "Home",
    nav_discover: "Discover our plans",
    nav_books: "Our Art Books",
    nav_crafts: "Crafts & Memory",
    nav_navigation: "Navigation",

    // ── Welcome ──
    dash_welcome: "Welcome to your sanctuary,",
    dash_welcome_member: "dear member",
    dash_welcome_text: "Your story begins here. Every photo you upload is a mark you leave for time.",
    dash_drag_drop: "or drag and drop your photos here",
    dash_drop_here: "Drop your memories here",

    // ── SAS ──
    dash_sas_label: "Sorting Area",
    dash_sas_waiting: "awaiting sorting — 30 days before deletion",
    dash_sort: "Sort",

    // ── Batch ──
    dash_batch_modify_date: "Edit date",
    dash_batch_same_date_single: "The same date will be applied to the selected photo.",
    dash_batch_same_date_plural: "The same date will be applied to all selected photos.",
    dash_apply: "Apply",
    dash_applying: "Applying...",
    dash_batch_delete_confirm: "Delete",
    dash_batch_deleting: "Deleting...",

    // ── Éclaireur ──
    ecl_title: "The Scout",
    ecl_invite_title: "Invite a Scout",
    ecl_subtitle: "invites you to illuminate their memories",
    ecl_enter_name: "Your first name to participate",
    ecl_choose_photos: "Choose photos to share",
    ecl_choose_memories: "Choose memories to share",
    ecl_select_all: "Select all",
    ecl_deselect_all: "Deselect all",
    ecl_selected: "selected",
    ecl_selected_plural: "selected",
    ecl_message_placeholder: "A personal message (optional)",
    ecl_send_invitation: "Send invitation",
    ecl_link_ready: "Magic Link ready!",
    ecl_magic_link: "Your Magic Link",
    ecl_copy_link: "Copy link",
    ecl_copied: "Copied!",
    ecl_generating: "Generating...",
    ecl_generate_link: "Generate Magic Link",
    ecl_link_created: "Magic Link created!",
    ecl_link_share_desc: "Share this link with your loved ones to illuminate your memories.",
    ecl_share_whatsapp: "Share on WhatsApp",
    ecl_whatsapp_share_msg: "Hey, it's {name}! Check out this memory I found on Bobine. You're going to love it!",
    ecl_memories_shared: "memory shared",
    ecl_memories_shared_plural: "memories shared",
    ecl_comment_placeholder: "Share your memory...",
    ecl_send_comment: "Send",
    ecl_record_voice: "Record a voice story",
    ecl_comments_title: "Comments",
    ecl_whatsapp_btn: "I'm done — Notify on WhatsApp",
    ecl_whatsapp_msg: "Hey! I just added a little piece of our story to your Bobine Silk Thread. 🕊️ What a joy to relive these moments... Can't wait for you to hear it! ✨",
    ecl_listen: "Listen",
    ecl_stop: "Stop",
    ecl_transcription: "Transcription",
    ecl_tap_to_comment: "Tap a photo to comment or record a voice memory",

    // ── Viewer ──
    viewer_sealed_on: "Sealed on",
    viewer_add_caption: "Add a caption...",
    viewer_restore_progress: "Restoring brilliance...",
    viewer_restore_title: "Renaissance Restoration",
    viewer_before: "BEFORE",
    viewer_after: "AFTER",
    viewer_restore_btn: "Restore",
    viewer_close: "Close",
    viewer_comments: "Comments",
    restore_accept: "I approve this restoration",
    restore_reject: "No thanks, cancel",

    // ── Modération ──
    mod_pending: "Pending",
    mod_approve: "Approve",
    mod_reject: "Reject",
    mod_approved: "Approved",
    mod_no_pending: "No pending insights",
    mod_no_pending_sub: "Comments from your Scouts will appear here",
    mod_description: "Approve or reject comments left by your Scouts.",
    mod_visible_desc: "Approved comments will be visible on your Silk Thread.",

    // ── Fil de Soie ──
    silk_title: "The Silk Thread",
    silk_subtitle: "shares their memories with you",
    silk_close: "Close",

    // ── Partage ──
    share_title: "The Silk Thread",
    share_subtitle: "Share your treasures with loved ones",
    share_generate: "Generate a sharing link",
    share_message_placeholder: "A message to accompany your photos...",
    share_my_links: "MY ACTIVE LINKS",
    share_copy: "Copy",
    share_revoke: "Revoke",
    share_no_links: "No active links",

    // ── Audio ──
    audio_record: "Record a voice story",
    audio_recording: "Recording...",
    audio_stop: "Stop",
    audio_pause: "Pause",
    audio_resume: "Resume",
    audio_send: "Send",
    audio_delete: "Delete audio",
    audio_listen: "Listen",
    audio_transcription: "Transcription",

    // ── Services ──
    svc_subscription: "My Subscription",
    svc_lignees: "Heritage",
    svc_heritage: "Heritage",
    svc_eveil: "Awakening",
    svc_free: "Free — 50 Treasures",
    svc_heritage_desc: "€4.99/month — Unlimited Storage",
    svc_lignees_desc: "€4.99/month — Unlimited Storage",
    svc_upgrade: "Choose Heritage",
    svc_upgrade_lignees: "Choose Heritage",
    svc_manage_subscription: "Manage my subscription",
    svc_books: "Our Art Books",
    svc_discount: "-20% automatically applied on all books",
    svc_order: "Order",
    svc_redirect: "Redirecting...",
    svc_restore_free: "Restore now",
    svc_restore_paid: "Restore a photo",
    svc_digitize: "Digitize your Treasures",
    svc_digitize_desc: "Entrust your photos, albums and negatives to our conservator. Professional high-resolution scanning.",
    svc_discover: "Discover",
    svc_digitize_title: "Professional Scanning Service",
    svc_order_book: "Order my Book",
    svc_treasures: "Treasures",
    svc_unlimited: "Unlimited",
    svc_request_sent: "Request sent!",
    svc_request_sent_desc: "Your request has been sent to our conservator. We will get back to you within 24h.",

    // ── Quota ──
    quota_message: "You have sealed your first Treasures successfully. To continue protecting your family history, upgrade to a higher plan or activate your subscription.",

    // ── Doublons ──
    dup_title: "Duplicates detected",
    dup_found: "duplicate(s) found",
    dup_group: "Duplicate group",
    dup_keep: "Keep",
    dup_remove: "Delete",
    dup_no_duplicates: "No duplicates detected",
    dup_scanning: "Scanning...",
    dup_banner_desc: "identical photos found in your vault",
    dup_manage: "Manage duplicates",
    dup_select_to_delete: "Select the photos to delete in each group",
    dup_delete_selected: "Delete selected duplicates",
    dup_identical: "identical photos",
    dup_clean_success: "Duplicates deleted successfully",

    // ── Général ──
    loading: "Loading...",
    error: "Error",
    success: "Success",
    confirm: "Confirm",
    cancel: "Cancel",
    close: "Close",
    save: "Save",
    photos: "photos",
    photo: "photo",

    // ── Book / Grid ──
    book_photos_count: "photos in your Book",
    book_preserve_dna: "Preserve your memories' DNA",
    book_in_book: "IN THE BOOK",
    book_add: "Add to book",
    book_remove: "Remove from book",
    view_grid: "Grid",
    view_timeline: "Timeline",

    // ── Verify Email ──
    verify_title: "Verify your email",
    verify_desc: "A 6-digit code has been sent to",
    verify_enter_code: "Enter the code received",
    verify_confirm: "Confirm",
    verify_confirming: "Verifying...",
    verify_not_received: "Didn't receive the code?",
    verify_resend: "Resend code",
    verify_resending: "Sending...",
    verify_resent: "Code resent!",
    verify_logout: "Log out",

    // ── Landing ──
    landing_hero: "Bring your forgotten memories back to life",
    landing_cta: "Get started",
    landing_skip: "SKIP",
    home_slogan: "Your memory vault",
    home_discover: "Discover Bobine",
    home_upload: "Upload your memories",
    home_drag_drop: "or drag and drop your photos here",
    home_save: "Save to my vault",
    home_saved: "Saved to My Treasures!",
    home_replay: "Replay introduction",
    fondatrice_desc: "The story of Bobine, told by the woman who imagined it.",
    ob_slide1: "Bring your forgotten memories back to life",
    ob_slide2: "Your family heritage, sealed for eternity",
    ob_video_text: "The thread is in your hands, seal your story.",
    ob_cta_text: "The thread is in your hands,",
    ob_cta_text2: "seal your story.",
    ob_enter: "Enter the Vault",
    ob_next: "Next",
    ob_replay: "Replay introduction",
    ob_skip: "Skip",
    loader_preparing: "Preparing",
    loader_turbo: "Turbo Upload",
    loader_photos_sec: "photos/s",
    loader_finalizing: "Finalizing your collection...",
    loader_remaining: "remaining",
    badge_sovereignty: "Swiss Sovereignty",
    badge_sovereignty_desc: "Your memories are encrypted and hosted in Switzerland",
    murmure_open: "Dive back into my memories",
    share_video: "Share",
    fondatrice_trial_cta: "Discover the Bobine vault: 30 days of serenity, free",
  },

  es: {
    // ── Auth ──
    auth_title: "Acceder a mi Cofre",
    auth_register_title: "Crear mi Cofre",
    auth_email: "Correo electrónico",
    auth_password: "Contraseña",
    auth_name: "Tu nombre",
    auth_login: "Entrar",
    auth_register: "Crear mi cuenta",
    auth_forgot: "¿Olvidaste tu contraseña?",
    auth_back_login: "Volver al inicio de sesión",
    auth_no_account: "¿Aún no tienes cofre?",
    auth_has_account: "¿Ya tienes un cofre?",
    auth_create: "Crear uno",
    auth_connect: "Iniciar sesión",
    auth_reset_title: "Restablecer contraseña",
    auth_reset_code: "Código recibido por email",
    auth_new_password: "Nueva contraseña",
    auth_reset_submit: "Cambiar contraseña",
    auth_reset_sent: "Se ha enviado un código a tu email",
    auth_send_code: "Enviar código",

    // ── Dashboard ──
    dash_my_treasures: "Mis Tesoros",
    dash_eclairages: "Iluminaciones",
    dash_prestige: "Servicios Premium",
    dash_cercle: "Mi Circulo",
    family_title: "Circulo Familiar",
    family_desc: "Invita hasta 5 seres queridos a consultar y alimentar tu Tronco Comun. Tus recuerdos privados siguen siendo privados.",
    family_create: "Crear mi Circulo Familiar",
    family_heritage_required: "El Circulo Familiar esta incluido en el plan Heritage.",
    family_see_plans: "Descubrir Heritage",
    family_my_circle: "Mi Circulo Familiar",
    family_guardian_label: "Eres el Guardian",
    family_members: "miembros",
    family_invite_prompt: "Invitar a un ser querido por email",
    family_invite_send: "Invitar",
    family_members_title: "Miembros del Circulo",
    family_no_members: "Sin miembros por ahora. Envia tu primera invitacion!",
    family_tronc_commun: "Tronco Comun",
    family_tronc_desc: "Comparte fotos desde la pestana \"Mis Tesoros\" para hacerlas visibles a tu Circulo.",
    family_refresh: "Actualizar",
    family_circle_of: "Circulo de",
    family_member_label: "Eres miembro",
    family_leave: "Dejar el Circulo",
    family_load_photos: "Cargar recuerdos compartidos",
    family_no_shared: "El Guardian aun no ha compartido recuerdos en el Tronco Comun.",
    family_gauge_label: "Plazas en tu circulo",
    family_seats_left: "plazas disponibles",
    family_seat_left: "plaza disponible",
    family_full: "Tu Circulo esta completo",
    // ── L'Alliance (Apadrinamiento) ──
    alliance_tab: "La Alianza",
    alliance_title: "La Alianza",
    alliance_subtitle: "Recomienda a un ser querido y cada uno recibe 1 mes gratis",
    alliance_your_code: "Tu codigo de recomendacion",
    alliance_share_link: "Enlace de recomendacion",
    alliance_copy: "Copiar",
    alliance_copied: "Copiado!",
    alliance_share_whatsapp: "Compartir por WhatsApp",
    alliance_share_text: "Unete a Bobine, la boveda de recuerdos! Usa mi codigo para 1 mes gratis:",
    alliance_how_title: "Como funciona?",
    alliance_step1: "Comparte tu enlace con un ser querido",
    alliance_step2: "Tu ahijado crea su cuenta con tu codigo",
    alliance_step3: "Cuando se suscribe, ambos reciben 1 mes gratis",
    alliance_my_referrals: "Mis ahijados",
    alliance_no_referrals: "Aun no hay ahijados. Comparte tu enlace!",
    alliance_status_pending: "Pendiente",
    alliance_status_active: "1 mes gratis",
    alliance_bonus_used: "Tu mes gratis ha sido aplicado",
    alliance_bonus_available: "Tu bono se aplicara cuando un ahijado se suscriba",
    alliance_one_bonus_note: "Un bono de recomendacion por usuario",
    dash_add_video: "A\u00f1adir una bobina viva",
    dash_videos_title: "Bobine Vive — recuerdos en movimiento",
    ecl_send_by_email: "Enviar por email",
    ecl_email_placeholder: "Email de su ser querido",
    ecl_email_sent: "\u00a1Email enviado!",
    ecl_email_sending: "Enviando...",
    album_all: "Todos",
    album_create: "Album",
    album_name_placeholder: "Nombre del album...",
    album_confirm: "Crear",
    dash_timeline: "Línea de tiempo",
    dash_vault_title: "Mi Cofre",
    dash_my_account: "Mi Cuenta",
    dash_sas_full_title: "El Tamiz",
    dash_upload: "Añadir Tesoros",
    dash_select: "Seleccionar",
    dash_cancel: "Cancelar",
    dash_invite_eclaireur: "Invitar un Explorador",
    dash_share_silk: "El Hilo de Seda — Compartir mis Tesoros",
    dash_treasures_sealed: "Tesoros sellados",
    video_too_large: "Este recuerdo es demasiado pesado para sellarse de una vez (máx 500 MB).",
    dash_add_treasure: "Añadir un Tesoro",
    dash_share_desc: "Comparte tus Tesoros en solo lectura con tus seres queridos.",
    dash_delete_selected: "Eliminar",
    dash_logout: "Salir",
    menu_account: "Mi Perfil",
    menu_billing: "Facturación",
    menu_plans: "Ofertas y Precios",
    account_title: "Mi Perfil",
    account_since: "Miembro desde",
    profile_language: "Idioma",
    account_vault: "Mi Cofre de un vistazo",
    account_photos: "Fotos en stock",
    account_used: "utilizado",
    account_sas: "En la B\u00f3veda",
    account_book: "En el Libro",
    account_restored: "Restauradas",
    account_encrypted: "Cifradas S3",
    account_livres: "Libros pedidos",
    account_num: "Digitalizaciones",
    account_eclaireurs: "Mis Exploradores",
    account_no_eclaireurs: "Ning\u00fan explorador invitado todav\u00eda",
    account_comments: "Comentarios recibidos",
    account_subscription: "Mi Suscripci\u00f3n",
    account_billing: "Facturaci\u00f3n",
    account_upgrade: "Cambiar plan",
    account_shares: "Enlaces compartidos",
    dash_no_photos: "Tu cofre está vacío",
    dash_no_photos_sub: "Sube tus primeros tesoros para empezar",
    dash_sas_title: "El Tamiz",
    dash_sas_desc: "fotos por clasificar",
    dash_restore: "Restaurar",
    dash_edit_date: "Editar fecha",
    dash_delete: "Eliminar",
    dash_back: "Volver",
    dash_back_vault: "Volver al Cofre",
    dash_remaining: "restante",
    dash_remaining_plural: "restantes",
    dash_board: "Panel de control",

    // ── Navigation ──
    nav_home: "Inicio",
    nav_discover: "Descubrir nuestros planes",
    nav_books: "Nuestros Libros de Arte",
    nav_crafts: "Artesanía & Memoria",
    nav_navigation: "Navegación",

    // ── Welcome ──
    dash_welcome: "Bienvenido a tu santuario,",
    dash_welcome_member: "querido miembro",
    dash_welcome_text: "Tu historia comienza aquí. Cada foto que subes es una huella que dejas al tiempo.",
    dash_drag_drop: "o arrastra y suelta tus fotos aquí",
    dash_drop_here: "Suelta tus recuerdos aquí",

    // ── SAS ──
    dash_sas_label: "Área de clasificación",
    dash_sas_waiting: "en espera de clasificación — 30 días antes de eliminar",
    dash_sort: "Clasificar",

    // ── Batch ──
    dash_batch_modify_date: "Editar fecha",
    dash_batch_same_date_single: "La misma fecha se aplicará a la foto seleccionada.",
    dash_batch_same_date_plural: "La misma fecha se aplicará a todas las fotos seleccionadas.",
    dash_apply: "Aplicar",
    dash_applying: "Aplicando...",
    dash_batch_delete_confirm: "Eliminar",
    dash_batch_deleting: "Eliminando...",

    // ── Éclaireur ──
    ecl_title: "El Explorador",
    ecl_invite_title: "Invitar un Explorador",
    ecl_subtitle: "te invita a iluminar sus recuerdos",
    ecl_enter_name: "Tu nombre para participar",
    ecl_choose_photos: "Elige las fotos a compartir",
    ecl_choose_memories: "Elige los recuerdos a compartir",
    ecl_select_all: "Seleccionar todo",
    ecl_deselect_all: "Deseleccionar todo",
    ecl_selected: "seleccionado",
    ecl_selected_plural: "seleccionados",
    ecl_message_placeholder: "Un mensaje personal (opcional)",
    ecl_send_invitation: "Enviar invitación",
    ecl_link_ready: "¡Enlace Mágico listo!",
    ecl_magic_link: "Tu Enlace Mágico",
    ecl_copy_link: "Copiar enlace",
    ecl_copied: "¡Copiado!",
    ecl_generating: "Generando...",
    ecl_generate_link: "Generar Enlace Mágico",
    ecl_link_created: "¡Enlace Mágico creado!",
    ecl_link_share_desc: "Comparte este enlace con tus seres queridos para que iluminen tus recuerdos.",
    ecl_share_whatsapp: "Compartir en WhatsApp",
    ecl_whatsapp_share_msg: "Hola, soy {name}! Mira este recuerdo que encontré en Bobine. Te va a encantar!",
    ecl_memories_shared: "recuerdo compartido",
    ecl_memories_shared_plural: "recuerdos compartidos",
    ecl_comment_placeholder: "Comparte tu recuerdo...",
    ecl_send_comment: "Enviar",
    ecl_record_voice: "Grabar un relato vocal",
    ecl_comments_title: "Comentarios",
    ecl_whatsapp_btn: "He terminado — Avisar por WhatsApp",
    ecl_whatsapp_msg: "¡Hola! Acabo de dejar un pedacito de nuestra historia en tu Hilo de Seda Bobine. 🕊️ ¡Qué alegría revivir estos momentos... Estoy deseando que lo escuches! ✨",
    ecl_listen: "Escuchar",
    ecl_stop: "Parar",
    ecl_transcription: "Transcripción",
    ecl_tap_to_comment: "Toca una foto para comentar o grabar un recuerdo vocal",

    // ── Viewer ──
    viewer_sealed_on: "Sellado el",
    viewer_add_caption: "Añadir una leyenda...",
    viewer_restore_progress: "Restaurando el brillo...",
    viewer_restore_title: "Restauración Renacimiento",
    viewer_before: "ANTES",
    viewer_after: "DESPUES",
    viewer_restore_btn: "Restaurar",
    viewer_close: "Cerrar",
    viewer_comments: "Comentarios",
    restore_accept: "Valido esta restauración",
    restore_reject: "No gracias, cancelar",

    // ── Modération ──
    mod_pending: "Pendiente",
    mod_approve: "Aprobar",
    mod_reject: "Rechazar",
    mod_approved: "Aprobado",
    mod_no_pending: "Sin iluminaciones pendientes",
    mod_no_pending_sub: "Los comentarios de tus Exploradores aparecerán aquí",
    mod_description: "Aprueba o rechaza los comentarios dejados por tus Exploradores.",
    mod_visible_desc: "Los comentarios aprobados serán visibles en tu Hilo de Seda.",

    // ── Fil de Soie ──
    silk_title: "El Hilo de Seda",
    silk_subtitle: "comparte sus recuerdos contigo",
    silk_close: "Cerrar",

    // ── Partage ──
    share_title: "El Hilo de Seda",
    share_subtitle: "Comparte tus tesoros con tus seres queridos",
    share_generate: "Generar un enlace para compartir",
    share_message_placeholder: "Un mensaje para acompañar tus fotos...",
    share_my_links: "MIS ENLACES ACTIVOS",
    share_copy: "Copiar",
    share_revoke: "Revocar",
    share_no_links: "Sin enlaces activos",

    // ── Audio ──
    audio_record: "Grabar un relato vocal",
    audio_recording: "Grabando...",
    audio_stop: "Parar",
    audio_pause: "Pausa",
    audio_resume: "Reanudar",
    audio_send: "Enviar",
    audio_delete: "Eliminar audio",
    audio_listen: "Escuchar",
    audio_transcription: "Transcripción",

    // ── Services ──
    svc_subscription: "Mi Suscripción",
    svc_lignees: "Herencia",
    svc_heritage: "Herencia",
    svc_eveil: "Despertar",
    svc_free: "Gratis — 50 Tesoros",
    svc_heritage_desc: "4,99€/mes — Almacenamiento Ilimitado",
    svc_lignees_desc: "4,99€/mes — Almacenamiento Ilimitado",
    svc_upgrade: "Elegir Herencia",
    svc_upgrade_lignees: "Elegir Herencia",
    svc_manage_subscription: "Gestionar mi suscripción",
    svc_books: "Nuestros Libros de Arte",
    svc_discount: "-20% aplicado automáticamente en todos los libros",
    svc_order: "Pedir",
    svc_redirect: "Redirigiendo...",
    svc_restore_free: "Restaurar ahora",
    svc_restore_paid: "Restaurar una foto",
    svc_digitize: "Digitalización de tus Tesoros",
    svc_digitize_desc: "Confía tus fotos, álbumes y negativos a nuestro conservador. Digitalización profesional de alta resolución.",
    svc_discover: "Descubrir",
    svc_digitize_title: "Servicio de Digitalización Pro",
    svc_order_book: "Pedir mi Libro",
    svc_treasures: "Tesoros",
    svc_unlimited: "Ilimitado",
    svc_request_sent: "¡Solicitud enviada!",
    svc_request_sent_desc: "Su solicitud ha sido enviada a nuestro conservador. Le contactaremos en menos de 24h.",

    // ── Quota ──
    quota_message: "Has sellado tus primeros Tesoros con éxito. Para seguir protegiendo la historia de tu linaje, pasa al plan superior o activa tu suscripción.",

    // ── Doublons ──
    dup_title: "Duplicados detectados",
    dup_found: "duplicado(s) encontrado(s)",
    dup_group: "Grupo de duplicados",
    dup_keep: "Conservar",
    dup_remove: "Eliminar",
    dup_no_duplicates: "No se detectaron duplicados",
    dup_scanning: "Analizando...",
    dup_banner_desc: "fotos idénticas encontradas en tu cofre",
    dup_manage: "Gestionar duplicados",
    dup_select_to_delete: "Selecciona las fotos a eliminar en cada grupo",
    dup_delete_selected: "Eliminar duplicados seleccionados",
    dup_identical: "fotos idénticas",
    dup_clean_success: "Duplicados eliminados con éxito",

    // ── Général ──
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    confirm: "Confirmar",
    cancel: "Cancelar",
    close: "Cerrar",
    save: "Guardar",
    photos: "fotos",
    photo: "foto",

    // ── Book / Grid ──
    book_photos_count: "fotos en tu Libro",
    book_preserve_dna: "Preserva el ADN de tus recuerdos",
    book_in_book: "EN EL LIBRO",
    book_add: "Añadir al libro",
    book_remove: "Quitar del libro",
    view_grid: "Cuadrícula",
    view_timeline: "Línea de tiempo",

    // ── Verify Email ──
    verify_title: "Verificación de tu email",
    verify_desc: "Se ha enviado un código de 6 dígitos a",
    verify_enter_code: "Ingresa el código recibido",
    verify_confirm: "Confirmar",
    verify_confirming: "Verificando...",
    verify_not_received: "¿No recibiste el código?",
    verify_resend: "Reenviar código",
    verify_resending: "Enviando...",
    verify_resent: "¡Código reenviado!",
    verify_logout: "Cerrar sesión",

    // ── Landing ──
    landing_hero: "Dale vida a tus recuerdos olvidados",
    landing_cta: "Empezar",
    landing_skip: "SALTAR",
    home_slogan: "Tu cofre de recuerdos",
    home_discover: "Descubrir Bobine",
    home_upload: "Sube tus recuerdos",
    home_drag_drop: "o arrastra y suelta tus fotos aquí",
    home_save: "Guardar en mi cofre",
    home_saved: "¡Guardado en Mis Tesoros!",
    home_replay: "Ver introducción de nuevo",
    fondatrice_desc: "La historia de Bobine, contada por quien la imaginó.",
    ob_slide1: "Dale vida a tus recuerdos olvidados",
    ob_slide2: "El patrimonio de tu linaje, sellado para la eternidad",
    ob_video_text: "El hilo está en tus manos, sella tu historia.",
    ob_cta_text: "El hilo está en tus manos,",
    ob_cta_text2: "sella tu historia.",
    ob_enter: "Entrar al Cofre",
    ob_next: "Siguiente",
    ob_replay: "Ver introducción de nuevo",
    ob_skip: "Saltar",
    loader_preparing: "Preparación",
    loader_turbo: "Turbo Upload",
    loader_photos_sec: "fotos/s",
    loader_finalizing: "Finalizando tu colección...",
    loader_remaining: "restante(s)",
    badge_sovereignty: "Soberanía Suiza",
    badge_sovereignty_desc: "Tus recuerdos están cifrados y alojados en Suiza",
    murmure_open: "Sumergirme en mis recuerdos",
    share_video: "Compartir",
    fondatrice_trial_cta: "Descubra el cofre Bobine: 30 d\u00edas de serenidad gratis",
  },

  pt: {
    // ── Auth ──
    auth_title: "Aceder ao meu Cofre",
    auth_register_title: "Criar o meu Cofre",
    auth_email: "Endereco de email",
    auth_password: "Palavra-passe",
    auth_name: "O seu primeiro nome",
    auth_login: "Entrar",
    auth_register: "Criar a minha conta",
    auth_forgot: "Esqueceu a palavra-passe?",
    auth_back_login: "Voltar ao login",
    auth_no_account: "Ainda sem cofre?",
    auth_has_account: "Ja tem um cofre?",
    auth_create: "Criar um",
    auth_connect: "Iniciar sessao",
    auth_reset_title: "Redefinir palavra-passe",
    auth_reset_code: "Codigo recebido por email",
    auth_new_password: "Nova palavra-passe",
    auth_reset_submit: "Alterar palavra-passe",
    auth_reset_sent: "Um codigo foi enviado para o seu email",
    auth_send_code: "Enviar codigo",
    // ── Dashboard ──
    dash_my_treasures: "Os Meus Tesouros",
    dash_eclairages: "Iluminacoes",
    dash_prestige: "Servicos Prestigio",
    dash_cercle: "O Meu Circulo",
    family_title: "Circulo Familiar",
    family_desc: "Convide ate 5 pessoas proximas para consultar e alimentar o seu Tronco Comum. Os seus tesouros privados permanecem privados.",
    family_create: "Criar o meu Circulo Familiar",
    family_heritage_required: "O Circulo Familiar esta incluido na oferta Heritage.",
    family_see_plans: "Descobrir o Heritage",
    family_my_circle: "O Meu Circulo Familiar",
    family_guardian_label: "Voce e o Guardiao",
    family_members: "membros",
    family_invite_prompt: "Convidar um proximo por email",
    family_invite_send: "Convidar",
    family_members_title: "Membros do Circulo",
    family_no_members: "Nenhum membro por enquanto. Envie o seu primeiro convite!",
    family_tronc_commun: "Tronco Comum",
    family_tronc_desc: "Partilhe fotos a partir do separador \"Os Meus Tesouros\" para as tornar visiveis ao seu Circulo.",
    family_refresh: "Atualizar",
    family_circle_of: "Circulo de",
    family_member_label: "Voce e membro",
    family_leave: "Sair do Circulo",
    family_load_photos: "Carregar as recordacoes",
    family_no_shared: "O Guardiao ainda nao partilhou recordacoes no Tronco Comum.",
    family_gauge_label: "Lugares no seu estojo",
    family_seats_left: "lugares disponiveis",
    family_seat_left: "lugar disponivel",
    family_full: "O seu Circulo esta completo",
    // ── L'Alliance (Apadrinhamento) ──
    alliance_tab: "A Alianca",
    alliance_title: "A Alianca",
    alliance_subtitle: "Apadrinhe um proximo e receba cada um 1 mes oferecido",
    alliance_your_code: "O seu codigo de apadrinhamento",
    alliance_share_link: "Link de apadrinhamento",
    alliance_copy: "Copiar",
    alliance_copied: "Copiado!",
    alliance_share_whatsapp: "Partilhar via WhatsApp",
    alliance_share_text: "Junta-te a mim no Bobine, o cofre-forte de recordacoes! Usa o meu codigo para receber 1 mes oferecido:",
    alliance_how_title: "Como funciona?",
    alliance_step1: "Partilhe o seu link com um proximo",
    alliance_step2: "O seu afilhado cria a conta com o seu codigo",
    alliance_step3: "Assim que subscrever, recebem cada um 1 mes oferecido",
    alliance_my_referrals: "Os meus afilhados",
    alliance_no_referrals: "Nenhum afilhado por enquanto. Partilhe o seu link!",
    alliance_status_pending: "Pendente",
    alliance_status_active: "1 mes oferecido",
    alliance_bonus_used: "O seu mes oferecido foi aplicado",
    alliance_bonus_available: "O seu bonus sera aplicado assim que um afilhado subscrever",
    alliance_one_bonus_note: "Um bonus de apadrinhamento por utilizador",
    dash_add_video: "Adicionar uma bobina viva",
    dash_videos_title: "Bobine Viva — recordacoes em movimento",
    ecl_send_by_email: "Enviar por email",
    ecl_email_placeholder: "Email do seu ente querido",
    ecl_email_sent: "Email enviado!",
    ecl_email_sending: "Enviando...",
    album_all: "Todos",
    album_create: "Album",
    album_name_placeholder: "Nome do album...",
    album_confirm: "Criar",
    dash_timeline: "Cronologia",
    dash_vault_title: "O Meu Cofre-forte",
    dash_my_account: "A Minha Conta",
    dash_sas_full_title: "A Passagem pelo Crivo",
    dash_upload: "Depositar Tesouros",
    dash_select: "Selecionar",
    dash_cancel: "Cancelar",
    dash_invite_eclaireur: "Convidar um Iluminador",
    dash_share_silk: "O Fio de Seda — Partilhar os meus Tesouros",
    dash_treasures_sealed: "Tesouros selados",
    video_too_large: "Esta lembrança é um pouco pesada demais para ser selada de uma vez (máx 500 MB).",
    dash_add_treasure: "+ Adicionar um Tesouro",
    dash_share_desc: "Partilhe os seus Tesouros em modo leitura com os seus proximos.",
    dash_logout: "Sair",
    menu_account: "O Meu Perfil",
    menu_billing: "Faturacao",
    menu_plans: "Ofertas & Precos",
    account_title: "O Meu Perfil",
    account_since: "Membro desde",
    profile_language: "Idioma",
    account_vault: "O Meu Cofre-forte num relance",
    account_photos: "Fotos em stock",
    account_used: "utilizado",
    account_sas: "No Crivo",
    account_book: "No Livro",
    account_restored: "Restauradas",
    account_encrypted: "Encriptadas S3",
    account_livres: "Livros encomendados",
    account_num: "Digitalizacoes",
    account_eclaireurs: "Os Meus Iluminadores",
    account_no_eclaireurs: "Nenhum iluminador convidado por enquanto",
    account_comments: "Comentarios recebidos",
    account_subscription: "A Minha Subscricao",
    account_billing: "Faturacao",
    account_upgrade: "Mudar de oferta",
    account_shares: "Links de partilha",
    dash_no_photos: "O seu cofre esta vazio",
    dash_no_photos_sub: "Deposite os seus primeiros tesouros para comecar",
    dash_sas_title: "Passagem pelo Crivo",
    dash_sas_desc: "fotos para triar",
    dash_restore: "Restaurar",
    dash_edit_date: "Modificar a data",
    dash_delete: "Eliminar",
    dash_delete_selected: "Eliminar",
    dash_back: "Voltar",
    dash_back_vault: "Voltar ao Cofre-forte",
    dash_remaining: "restante",
    dash_remaining_plural: "restantes",
    dash_board: "Painel de Controlo",
    // ── Navigation ──
    nav_home: "Inicio",
    nav_discover: "Descobrir as nossas formulas",
    nav_books: "Os Nossos Livros de Arte",
    nav_crafts: "Artesanato & Memoria",
    nav_navigation: "Navegacao",
    // ── Welcome ──
    dash_welcome: "Bem-vindo ao seu santuario,",
    dash_welcome_member: "caro membro",
    dash_welcome_text: "O fio da sua historia comeca aqui. Cada foto que deposita e uma marca que deixa ao tempo.",
    dash_drag_drop: "ou arraste as suas fotos para aqui",
    dash_drop_here: "Deposite as suas recordacoes aqui",
    // ── SAS ──
    dash_sas_label: "Crivo de Triagem",
    dash_sas_waiting: "em espera de triagem — 30 dias antes da eliminacao",
    dash_sort: "Triar",
    // ── Batch ──
    dash_batch_modify_date: "Modificar a data",
    dash_batch_same_date_single: "A mesma data sera aplicada a foto selecionada.",
    dash_batch_same_date_plural: "A mesma data sera aplicada a todas as fotos selecionadas.",
    dash_apply: "Aplicar",
    dash_applying: "A aplicar...",
    dash_batch_delete_confirm: "Eliminar",
    dash_batch_deleting: "A eliminar...",
    // ── Eclaireur ──
    ecl_title: "O Iluminador",
    ecl_invite_title: "Convidar um Iluminador",
    ecl_subtitle: "convida-o a iluminar as suas recordacoes",
    ecl_enter_name: "O seu nome para participar",
    ecl_choose_photos: "Escolha as fotos a partilhar",
    ecl_choose_memories: "Escolha as recordacoes a partilhar",
    ecl_select_all: "Selecionar tudo",
    ecl_deselect_all: "Desselecionar tudo",
    ecl_selected: "selecionado",
    ecl_selected_plural: "selecionados",
    ecl_message_placeholder: "Uma mensagem pessoal (opcional)",
    ecl_send_invitation: "Enviar o convite",
    ecl_link_ready: "Link Magico pronto!",
    ecl_magic_link: "O seu Link Magico",
    ecl_copy_link: "Copiar o link",
    ecl_copied: "Copiado!",
    ecl_generating: "A gerar...",
    ecl_generate_link: "Gerar o Link Magico",
    ecl_link_created: "Link Magico criado!",
    ecl_link_share_desc: "Partilhe este link com os seus proximos para que iluminem as suas recordacoes.",
    ecl_share_whatsapp: "Partilhar no WhatsApp",
    ecl_whatsapp_share_msg: "Ola, sou o/a {name}! Olha esta recordacao que encontrei no Bobine. Vai adorar!",
    ecl_memories_shared: "recordacao partilhada",
    ecl_memories_shared_plural: "recordacoes partilhadas",
    ecl_comment_placeholder: "Partilhe a sua recordacao...",
    ecl_send_comment: "Enviar",
    ecl_record_voice: "Confiar um relato vocal",
    ecl_comments_title: "Comentarios",
    ecl_tap_to_comment: "Toque numa foto para comentar ou confiar um relato vocal",
    ecl_whatsapp_btn: "Terminei — Avisar no WhatsApp",
    ecl_whatsapp_msg: "Ola! Acabei de depositar um pedaco da nossa historia no teu Fio de Seda Bobine. Que prazer rever estes momentos... Mal posso esperar que o oicas!",
    ecl_listen: "Ouvir",
    ecl_stop: "Parar",
    ecl_transcription: "Transcricao",
    // ── Viewer ──
    viewer_sealed_on: "Selado em",
    viewer_add_caption: "Adicionar uma legenda...",
    viewer_restore_progress: "Restauracao do brilho em curso...",
    viewer_restore_title: "Restauracao Renascenca",
    viewer_before: "ANTES",
    viewer_after: "DEPOIS",
    viewer_restore_btn: "Restaurar",
    viewer_close: "Fechar",
    viewer_comments: "Comentarios",
    restore_accept: "Valido esta restauracao",
    restore_reject: "Nao obrigado, cancelar",
    // ── Moderacao ──
    mod_pending: "Pendente",
    mod_approve: "Aprovar",
    mod_reject: "Rejeitar",
    mod_approved: "Aprovado",
    mod_no_pending: "Nenhuma iluminacao pendente",
    mod_no_pending_sub: "Os comentarios dos seus Iluminadores aparecerrao aqui",
    mod_description: "Aprove ou rejeite os comentarios deixados pelos seus Iluminadores.",
    mod_visible_desc: "Os comentarios aprovados serao visiveis no seu Fio de Seda.",
    // ── Fio de Seda ──
    silk_title: "O Fio de Seda",
    silk_subtitle: "partilha as suas recordacoes consigo",
    silk_close: "Fechar",
    // ── Partilha ──
    share_title: "O Fio de Seda",
    share_subtitle: "Partilhe os seus tesouros com os seus proximos",
    share_generate: "Gerar um link de partilha",
    share_message_placeholder: "Uma mensagem para acompanhar as suas fotos...",
    share_my_links: "OS MEUS LINKS ATIVOS",
    share_copy: "Copiar",
    share_revoke: "Revogar",
    share_no_links: "Nenhum link ativo",
    // ── Audio ──
    audio_record: "Confiar um relato vocal",
    audio_recording: "A gravar...",
    audio_stop: "Parar",
    audio_pause: "Pausa",
    audio_resume: "Retomar",
    audio_send: "Enviar",
    audio_delete: "Eliminar o audio",
    audio_listen: "Ouvir",
    audio_transcription: "Transcricao",
    // ── Servicos ──
    svc_subscription: "A Minha Subscricao",
    svc_lignees: "A Heranca",
    svc_heritage: "A Heranca",
    svc_eveil: "O Despertar",
    svc_free: "Gratuito — 50 Tesouros",
    svc_heritage_desc: "4,99 EUR/mês — Armazenamento Ilimitado",
    svc_lignees_desc: "4,99 EUR/mês — Armazenamento Ilimitado",
    svc_upgrade: "Escolher a Heranca",
    svc_upgrade_lignees: "Escolher a Heranca",
    svc_manage_subscription: "Gerir a minha subscricao",
    svc_books: "Os Nossos Livros de Arte",
    svc_discount: "-20% aplicado automaticamente em todos os livros",
    svc_order: "Encomendar",
    svc_redirect: "Redirecionamento...",
    svc_restore_free: "Restaurar agora",
    svc_restore_paid: "Restaurar uma foto",
    svc_digitize: "Digitalizacao dos seus Tesouros",
    svc_digitize_desc: "Confie as suas fotos, albuns e negativos ao nosso conservador. Digitalizacao profissional de alta resolucao.",
    svc_discover: "Descobrir",
    svc_digitize_title: "Servico de Digitalizacao Pro",
    svc_order_book: "Encomendar o meu Livro",
    svc_treasures: "Tesouros",
    svc_unlimited: "Ilimitado",
    svc_request_sent: "Pedido transmitido!",
    svc_request_sent_desc: "O seu pedido foi transmitido ao nosso conservador. Contactaremos em 24h.",
    // ── Quota ──
    quota_message: "Selou os seus primeiros Tesouros com sucesso. Para continuar a proteger a historia da sua linhagem, passe para a oferta superior ou ative a sua subscricao.",
    // ── Doublons ──
    dup_title: "Duplicados detetados",
    dup_found: "duplicado(s) encontrado(s)",
    dup_group: "Grupo de duplicados",
    dup_keep: "Manter",
    dup_remove: "Eliminar",
    dup_no_duplicates: "Nenhum duplicado detetado",
    dup_scanning: "Analise em curso...",
    dup_banner_desc: "fotos identicas encontradas no seu cofre",
    dup_manage: "Gerir os duplicados",
    dup_select_to_delete: "Selecione as fotos a eliminar em cada grupo",
    dup_delete_selected: "Eliminar os duplicados selecionados",
    dup_identical: "fotos identicas",
    dup_clean_success: "Duplicados eliminados com sucesso",
    // ── Geral ──
    loading: "A carregar...",
    error: "Erro",
    success: "Sucesso",
    confirm: "Confirmar",
    cancel: "Cancelar",
    close: "Fechar",
    save: "Guardar",
    photos: "fotos",
    photo: "foto",
    // ── Book / Grid ──
    book_photos_count: "fotos no seu Livro",
    book_preserve_dna: "Preserve o ADN das suas recordacoes",
    book_in_book: "NO LIVRO",
    book_add: "Adicionar ao livro",
    book_remove: "Retirar do livro",
    view_grid: "Grelha",
    view_timeline: "Cronologia",
    // ── Verify Email ──
    verify_title: "Verificacao do seu email",
    verify_desc: "Um codigo de 6 digitos foi enviado para",
    verify_enter_code: "Introduza o codigo recebido",
    verify_confirm: "Confirmar",
    verify_confirming: "A verificar...",
    verify_not_received: "Nao recebeu o codigo?",
    verify_resend: "Reenviar o codigo",
    verify_resending: "A enviar...",
    verify_resent: "Codigo reenviado!",
    verify_logout: "Terminar sessao",
    // ── Landing ──
    landing_hero: "De nova vida as suas recordacoes esquecidas",
    landing_cta: "Comecar",
    landing_skip: "PASSAR",
    home_slogan: "O seu cofre-forte de recordacoes",
    home_discover: "Descobrir Bobine",
    home_upload: "Depositar as suas recordacoes",
    home_drag_drop: "ou arraste as suas fotos para aqui",
    home_save: "Guardar no meu cofre",
    home_saved: "Guardado nos Meus Tesouros!",
    home_replay: "Rever a introducao",
    fondatrice_desc: "A historia de Bobine, contada por quem a imaginou.",
    ob_slide1: "De nova vida as suas recordacoes esquecidas",
    ob_slide2: "O patrimonio da sua linhagem, selado para a eternidade",
    ob_video_text: "O fio esta nas suas maos, sele a sua historia.",
    ob_cta_text: "O fio esta nas suas maos,",
    ob_cta_text2: "sele a sua historia.",
    ob_enter: "Entrar no Cofre-forte",
    ob_next: "Seguinte",
    ob_replay: "Rever a introducao",
    ob_skip: "Passar",
    loader_preparing: "Preparacao",
    loader_turbo: "Turbo Upload",
    loader_photos_sec: "fotos/s",
    loader_finalizing: "Finalizacao da sua colecao...",
    loader_remaining: "restante(s)",
    badge_sovereignty: "Soberania Suica",
    badge_sovereignty_desc: "As suas recordacoes sao encriptadas e alojadas na Suica",
    murmure_open: "Mergulhar nas minhas recordacoes",
    share_video: "Partilhar",
    fondatrice_trial_cta: "Descubra o cofre Bobine: 30 dias de serenidade gr\u00e1tis",
  },
};

export default translations;
